// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atis.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atis/atis.js';

mount([g0]);
